module.exports = __webpack_public_path__ + "img/1.bf44e4f1.png";